// extracted by mini-css-extract-plugin
export var lg = "_3g-4";
export var md = "_3g-3";
export var sm = "_3g-2";
export var xs = "_3g-1";
export var xxs = "_3g-0";